import React,{Fragment, useContext, useEffect,useState} from 'react'
import Axios from 'axios'
import moment from 'moment';
import {makeStyles } from '@material-ui/core';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Spinner } from 'react-bootstrap';
import { Grid } from '@mui/material';
import { Dropdown } from 'semantic-ui-react'
import { ButtonContent, Placeholder, Search, Icon} from "semantic-ui-react";
import WorkOrderGrid from './wo_grid/WorkOrderGrid';
import WorkOrderDetails from './wo_details/WorkOrderDetails';
import workorderStore from '../../../app/stores/workorderStore';
import userauthStore from '../../../app/stores/userauthStore';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { observer } from 'mobx-react-lite';
import AgedDebtDetails from './wo_details/AgedDebtDetails';
import AgedDebtGrid from './wo_grid/AgedDebtGrid';
import AllDetails from './wo_details/AllDetails';


const useStyles = makeStyles((theme) => ({   
    Container: {
        margin: "0 auto"
    },
    Spinner: {
        position: "fixed",
        top: "50%",
        left: "50%",
    },
    Dropdown: {
        paddingBottom: "10px",
        backgroundColor: "red"
    },
    H2:{
        textAlign: "center",
        margin:"0 auto",
        width: "100%"
    },
    Tradecode: {
        marginBottom: "15px",
        marginTop: "15px"

    },
    SearchContainer: {
        width: "100%",
        display:"flex"
    },
    SearchIcon: {
        paddingTop: "5px"
    }
}));


const AgedDebt = props => {
    const workOrderStore = useContext(workorderStore);
    const userAuthStore = useContext(userauthStore);

    let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!)
    let IsLoggedIn = sessionStorage.getItem("isLoggedIn")
    let CurrentModule = sessionStorage.getItem("module")

    useEffect(() => {
        userAuthStore.HydrateAuthState();
    }, [userAuthStore]);

    useEffect(() => {
        workOrderStore.loadAgedDebt(sessionObj.Client.Id,);
        console.log(workOrderStore.agedDebt)
    }, [workOrderStore, CurrentModule]);

    if (workOrderStore.loadinginitial)
        return <LoadingComponent content={"Loading: " + CurrentModule} inverted={true} />;


    return (
        <Fragment>
            <AgedDebtGrid workorders={workOrderStore.workorders} />
            <AgedDebtDetails/>
        </Fragment> 
 )};

 export default observer(AgedDebt);
